module.exports = __webpack_public_path__ + "static/researchGif-790ee361e553b8213b32f53888e123f0.gif";